import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import {
  createRatingOrder,
  type CreateRatingOrderBody,
} from './create-rating-order';

export interface CreateRatingOrderParams {
  orderId: string;
  body: CreateRatingOrderBody;
}

export const useCreateRatingOrder = (
  opts?: Omit<
    UseMutationOptions<any, DefaultQueryError, CreateRatingOrderParams>,
    'mutationFn'
  >
) =>
  useMutation<any, DefaultQueryError, CreateRatingOrderParams>({
    mutationKey: ['createRatingOrder'],
    mutationFn: ({ orderId, body }) => createRatingOrder(orderId, body),
    ...opts,
  });
